import React from "react";
import { Radio, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { FlexContainer } from "../../../shared/components/styled/Container.styled";
import { hex2rgba } from "../../../shared/utils/utility-functions";

const SelectedOption = ({
  label = "",
  InputItem = <></>,
  selected = false,
  setSelected = () => {},
  elementKey = "",
  padding = "25px",
  // Shared across the options of one setting so the browser treats them as a
  // single radio group, giving arrow-key navigation and "1 of 4" announcements.
  groupName = "",
}) => {
  const theme = useTheme();
  return (
    <FlexContainer
      flexdirection="column"
      alignitems="flex-start"
      justifycontent="flex-start"
      height="100%"
      minwidth="275px"
      width="100%"
      padding={padding}
      background={
        selected
          ? hex2rgba(theme.palette.primary.main, 0.14)
          : "rgba(0, 0, 0, 0.1)"
      }
      // Sized the same when unselected so choosing an option does not nudge the
      // row, and carried at 2px so the active card reads as picked from across
      // the form rather than only when compared against its neighbours.
      border={
        selected
          ? `2px solid ${theme.palette.primary.main}`
          : "2px solid transparent"
      }
      onClick={(e) => setSelected(elementKey)}
      sx={{
        cursor: "pointer",
        boxShadow: selected
          ? `0 12px 28px -10px ${hex2rgba(theme.palette.primary.main, 0.45)}`
          : "none",
        transition:
          "box-shadow 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out",
        flexBasis: "50%",
        "&:hover": {
          borderColor: selected
            ? theme.palette.primary.main
            : hex2rgba(theme.palette.primary.main, 0.4),
        },
      }}
    >
      <FlexContainer
        alignitems="center"
        justifycontent="flex-start"
        gap="8px"
        width="100%"
        sx={{ paddingBottom: "10px" }}
      >
        <Radio
          checked={selected}
          onChange={() => setSelected(elementKey)}
          onClick={(e) => e.stopPropagation()}
          value={elementKey}
          name={groupName || undefined}
          size="small"
          inputProps={{ "aria-label": label }}
          sx={{ padding: 0, color: "text.hint" }}
        />
        <Typography color={selected ? "primary" : "text.hint"} fontWeight="bold">
          {label}
        </Typography>
      </FlexContainer>
      {InputItem}
    </FlexContainer>
  );
};

export default SelectedOption;
